/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { AuthenticationService, Tokens } from '../shared/_generated/backend';
import { NotificationService } from '../shared/services/notification.sevice';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    constructor(
        private authenticationService: AuthenticationService,
        private router: Router,
        private notifier: NotificationService,
        private jwtHelperService: JwtHelperService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<object>> {
        let requestWithCorrectHeaders = request.clone();
        const accessToken = localStorage.getItem('accessToken');
        if (request.headers.get('authorization') === undefined || request.headers.get('authorization') === null
            && !request.url.includes('token-refresh')) {
            requestWithCorrectHeaders = request.clone({ headers: request.headers.set('authorization', `Bearer ${accessToken}`) });
        }

        return next.handle(requestWithCorrectHeaders).pipe(catchError(error => {
            if (error instanceof HttpErrorResponse
                && !request.url.includes('token-refresh')
                && !request.url.includes('login')
                && !request.url.includes('send-magic-link')
                && error.status === 401) {
                return this.handle401Error(requestWithCorrectHeaders, next);
            }
            return throwError(() => error);
        }));
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);
            const refreshtoken = localStorage.getItem('refreshToken');

            if (refreshtoken) {
                this.authenticationService.configuration.apiKeys = { refreshtoken };
                return this.authenticationService.refreshAccessToken().pipe(
                    switchMap((result: Tokens) => {
                        this.isRefreshing = false;
                        localStorage.setItem('accessToken', result.accessToken);
                        localStorage.setItem('refreshToken', result.refreshToken);
                        const decodedToken = this.jwtHelperService.decodeToken(result.refreshToken);

                        const refreshTokenExpiration = decodedToken.exp;
                        localStorage.setItem('refreshTokenExpiration', refreshTokenExpiration);
                        this.refreshTokenSubject.next(result.accessToken);
                        return next.handle(this.addTokenHeader(request, result.accessToken));
                    }),
                    catchError((err) => {
                        this.isRefreshing = false;
                        localStorage.clear();
                        this.router.navigateByUrl('/login');
                        this.notifier.showErrorSnackBar('A munkamenet lejárt.');
                        return throwError(() => err);
                    }));
            }
        }
        return this.refreshTokenSubject.pipe(
            filter(token => token !== null),
            take(1),
            switchMap((token) => next.handle(this.addTokenHeader(request, token)))
        );
    }

    private addTokenHeader(request: HttpRequest<any>, token: string) {
        return request.clone({ headers: request.headers.set('authorization', `Bearer ${token}`) });
    }

}
